import { FunctionComponent } from 'react';
import Box from '@mui/material/Box';
import FormHelperText from '@mui/material/FormHelperText';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import { useIsFieldRevertEnabled } from '../../FieldRevert/FieldRevertContext';
import { ACTION_BUTTON_SPACING } from './FieldControlInputContainer.constant';
import { FieldRevertRow } from './FieldRevertRow';
import { IFieldControlInputContainerProps } from './FieldControlInputContainer.interface';

const InputContainerColumn = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minWidth: 0,
  overflow: 'hidden',
});

export const FieldControlInputContainer: FunctionComponent<
  IFieldControlInputContainerProps
> = (props) => {
  const {
    children, name, errorMessage, action, alignSelf, bulkEdit, revertValue,
  } = props;

  const revertName = useIsFieldRevertEnabled() && name ? name : undefined;

  // Fields are full-length by default. When the revert feature is active the field
  // shrinks dynamically (see FieldRevertRow) only while dirty, so no static space is
  // reserved; otherwise bulk edit still reserves room on the right.
  const paddingRight = !revertName && bulkEdit ? ACTION_BUTTON_SPACING : 0;

  return (
    <InputContainerColumn>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: revertName ? 'center' : undefined,
          alignSelf: alignSelf,
          paddingRight: paddingRight,
          overflow: 'hidden',
        }}>
        {revertName
          ? <FieldRevertRow name={revertName} revertValue={revertValue}>{children}</FieldRevertRow>
          : children}
        {action}
      </Box>
      {errorMessage && (
        <Tooltip title={errorMessage} arrow={true}>
          <FormHelperText
            error={true}
            sx={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
            }}
          >
            {errorMessage}
          </FormHelperText>
        </Tooltip>
      )}
    </InputContainerColumn>
  );
};
